import { Component, Input, SimpleChanges } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from "../../../../globals";
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { DishFoodcostPersonsPage } from '../../../dish/dish-view/dish-foodcost-persons/dish-foodcost-persons';
import { DishServices } from '../../../dish/services';
import { DishIngredientsSelectPage } from '../../../dish/dish-create/dish-cost/dish-ingredients-select/dish-ingredients-select';
import { ProductCreateFoodcostSelectIngPage } from '../../../products/product-create/product-create-foodcost/product-create-foodcost-select-ing/product-create-foodcost-select-ing';
import { IngredientsServices } from '../../../ingredients/services';
import { ProductsServices } from '../../../products/services';
import { ProviderOrderAddPage } from '../../../providers/orders/provider-order-add/provider-order-add';
import { TranslateService } from '@ngx-translate/core';
import { IngredientViewPage } from '../../../ingredients/ingredient-view/ingredient-view/ingredient-view';

/**
 * Generated class for the ArticleViewFoodcostPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-article-view-foodcost',
  templateUrl: 'article-view-foodcost.html',
})
export class ArticleViewFoodcostPage {
  @Input() article: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public dishServices: DishServices,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public ingredientsServices: IngredientsServices,
    public productsServices: ProductsServices,
    public toastCtrl: ToastController,
    public translate: TranslateService) {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.article && this.article.UID) {
      if (this.article.type === 'dish') {
        this.stateDishStock();
      } else if (this.article.type === 'product' && this.article.sub_recipe) {
        this.stateProductStock();
      }
    }
  }

  edit() {
    if (this.article.type === 'dish') {
      if (this.globals.checkLimitsByLicense('dishes', 'foodcost')) {
        this.navCtrl.push(DishIngredientsSelectPage, {
          update: true,
          dish_uid: this.article.UID,
          foodcost: this.article.foodcost,
          foodcost_parts: this.article.foodcost_parts,
          foodcost_static: this.article.foodcost_static,
          dish_name: this.globals.nameLangSelectDish(this.article),
          dish: this.article
        });
      } else {
        this.navCtrl.push(AddonsTriggerVersionProPage);
      }
    } else {
      this.navCtrl.push(ProductCreateFoodcostSelectIngPage, {
        update_state: true,
        product_uid: this.article.UID,
        products: this.article,
        product_name: this.globals.nameLangSelectProduct(this.article),
        pvp: this.article.pvp,
        product: this.article
      });
    }
  }


  foodcostPersons() {
    if (this.globals.checkLimitsByLicense('dishes', 'foodcost')) {
      this.navCtrl.push(DishFoodcostPersonsPage, {
        dish_uid: this.article.UID,
        foodcost: this.article.foodcost,
        foodcost_parts: this.article.foodcost_parts,
        foodcost_static: this.article.foodcost_static,
        dish_name: this.globals.nameLangSelectDish(this.article),
        dish: this.article,
      });
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  public list_state: any = [];
  public max_create: any = 0;
  async stateDishStock() {
    this.list_state = [];
    var max_create = [];

    if (this.globals.checkLimitsByLicense('dishes', 'foodcost')) {
      var dish = await this.dishServices.getDish(this.article.UID);
      
      // Optimización: ejecutar todas las peticiones en paralelo en lugar de secuencialmente
      const ingredientPromises = dish.foodcost.map(async (foodcost) => {
        if (foodcost.type === undefined) {
          foodcost.type = 'ingredient';
        }
        const ing = foodcost.type === 'product'
          ? await this.productsServices.getProduct(foodcost.uid)
          : await this.ingredientsServices.getIngredient(foodcost.uid);
        
        return {
          foodcost: foodcost,
          ingredient: ing
        };
      });
      
      const results = await Promise.all(ingredientPromises);
      
      results.forEach(({ foodcost, ingredient }) => {
        this.list_state.push({
          name: foodcost.name_static,
          stock: ingredient.stock,
          measurement: ingredient.measurement,
          UID: ingredient.UID
        });
        var ing_stock = this.globals.returnBigtoLittleMeasurement(ingredient.stock, ingredient.measurement);
        max_create.push(ing_stock / (foodcost.quantity_gross / dish.foodcost_parts));
      });
      
      this.max_create = Math.min.apply(null, max_create);
      this.max_create = Math.trunc(this.max_create);
    }
  }

  async stateProductStock() {
    this.list_state = [];
    var max_create = [];

    if (this.globals.checkLimitsByLicense('stock', 'subrecipe')) {
      var product = await this.productsServices.getProduct(this.article.UID);
      if (product.foodcost) {
        // Optimización: ejecutar todas las peticiones en paralelo en lugar de secuencialmente
        const ingredientPromises = product.foodcost.map(foodcost =>
          this.ingredientsServices.getIngredient(foodcost.uid).then(ing => ({
            foodcost: foodcost,
            ingredient: ing
          }))
        );
        
        const results = await Promise.all(ingredientPromises);
        
        results.forEach(({ foodcost, ingredient }) => {
          this.list_state.push({
            name: foodcost.name_static,
            stock: ingredient.stock,
            measurement: ingredient.measurement,
            UID: ingredient.UID
          });
          var ing_stock = this.globals.returnBigtoLittleMeasurement(ingredient.stock, ingredient.measurement);
          max_create.push(ing_stock / (foodcost.quantity_gross / product.foodcost_parts));
        });
        
        this.max_create = Math.min.apply(null, max_create);
        this.max_create = Math.trunc(this.max_create);
      }
    }
  }

  openProviderOrderAdd(element) {
    if (this.globals.checkLimitsByLicense('dishes', 'foodcost')) {
      if (this.article.foodcost.length > 0) {
        this.navCtrl.push(ProviderOrderAddPage, {
          element: element,
          type: this.article.type
        });
      } else {
        let toast = this.toastCtrl.create({
          message: this.translate.instant('dish-view-sin-escandallo-no-podemos-entregarte-datos'),
          duration: 3000,
          position: 'bottom'
        });
        toast.present();
      }
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  openIngredientView(ingredient) {
    this.navCtrl.push(IngredientViewPage, {
      ingredient_uid: ingredient.UID,
      ingredient_name: ingredient.name
    });
  }

}


// WEBPACK FOOTER //
// ./src/pages/articles/articles-view/article-view-foodcost/article-view-foodcost.ts